import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="container-tight py-32 text-center" data-testid="not-found-page">
            <div className="font-mono text-6xl text-zinc-800">404</div>
            <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-white mt-6">Page not found</h1>
            <p className="text-zinc-400 mt-4 max-w-md mx-auto">
                The URL you followed doesn&apos;t match anything we&apos;ve reviewed. Try starting from the homepage.
            </p>
            <Link to="/" className="btn-primary mt-8" data-testid="home-link">Back to home</Link>
        </div>
    );
}
